export const SKILL_QUALIFICATION = [
  {label: 'Individual errands', value: 'INDIVIDUAL_ERRANDS'},
  {label: 'Food and Restaurant', value: 'FOOD_RESTAURANT'},
  {label: 'Parcels and Logistics', value: 'PARCELS_LOGISTICS'},
  {label: 'Warehousing and Manufacturing', value: 'WAREHOUSING_MANUFACTURING'},
  {label: 'Sales and Marketing', value: 'SALES_MARKETING'},
  {label: 'Parties and Events', value: 'MUSIC_BAND'},
  {label: 'Hotel and Hospitality Management', value: 'HOTEL_HOSPITALITY_MANAGEMENT'},
  {label: 'IT and Computer systems', value: 'IT_COMPUTER_SYSTEMS'},
  {label: 'Design and Graphics', value: 'DESIGN_GRAPHICS'},
  {label: 'Tutorial and consultation', value: 'TUTORIAL_CONSULTATION'},
  {label: 'Retail and Merchandising ', value: 'RETAIL_MERCHANDISING'}
]

export const SKILL_OFFER = [
  {label: 'Individual errands', value: 'INDIVIDUAL_ERRANDS'},
  {label: 'Food and Restaurant', value: 'FOOD_RESTAURANT'},
  {label: 'Parcels and Logistics', value: 'PARCELS_LOGISTICS'},
  {label: 'Warehousing and Manufacturing', value: 'WAREHOUSING_MANUFACTURING'},
  {label: 'Sales and Marketing', value: 'SALES_MARKETING'},
  {label: 'Parties and Events', value: 'MUSIC_BAND'},
  {label: 'Hotel and Hospitality Management', value: 'HOTEL_HOSPITALITY_MANAGEMENT'},
  {label: 'IT and Computer systems', value: 'IT_COMPUTER_SYSTEMS'},
  {label: 'Design and Graphics', value: 'DESIGN_GRAPHICS'},
  {label: 'Tutorial and consultation', value: 'TUTORIAL_CONSULTATION'},
  {label: 'Retail and Merchandising ', value: 'RETAIL_MERCHANDISING'}
]

export const INDIVIDUAL_ERRANDS = [
  'Haircut',
  'Massage',
  'Reflexology',
  'Manicurist',
  'Tattoo Artist',
  'Laundry Washer',
  'House Cleaning',
  'Aircon Repair',
  'Aircon Cleaning',
  'Aircon Installation',
  'Plumber',
  'Simple Carpentry',
  'Electrician',
  'House Painting',
  'Driver for a Day',
  'Van and Vehicle',
  'Motorcycle Riders',
  'Bikers',
  'Walkers'
]
export const FOOD_RESTAURANT = [
  'Service Crew',
  'Waiter',
  'Cook',
  'Dishwasher',
  'Repair and Maintenance',
  'Utility Cleaners'
]
export const PARCELS_LOGISTICS = [
  'Bulk Riders',
  'Movers',
  'Delivery Trucks',
  'Van and Vehicle',
  'Motorcycle Riders',
  'Dispatchers'
]
export const WAREHOUSING_MANUFACTURING = ['Sorters', 'Baggers', 'Pick and Packers']
export const SALES_MARKETING = ['Social Media Artist', 'Digital Marketing', 'Content Creator', 'SEO Writer']
export const MUSIC_BAND = [
  'Hosts',
  'Event Coordinators',
  'Clowns',
  'Magicians',
  'Entertainers',
  'Performers',
  'Bartenders',
  'Barista',
  'Cook',
  'Waiter',
  'Videographer',
  'Photographer'
]
export const HOTEL_HOSPITALITY_MANAGEMENT = ['Receptionist', 'Housekeeping', 'Ushers']
export const IT_COMPUTER_SYSTEMS = ['Computer Repair', 'Web Developer', 'UI/UX Designer']
export const DESIGN_GRAPHICS = ['Logo Creation', 'Background', 'Posters']
export const TUTORIAL_CONSULTATION = ['Life Coach', 'Financial Coach', 'Tutors']
export const RETAIL_MERCHANDISING = ['Sales Personnel', 'Promodizers', 'Sales Agents']
